'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestionHolder = require('./QuestionHolder');

var _QuestionHolder2 = _interopRequireDefault(_QuestionHolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MatrixRow = function (_Component) {
  _inherits(MatrixRow, _Component);

  function MatrixRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MatrixRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MatrixRow.__proto__ || Object.getPrototypeOf(MatrixRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (questionId, questionValue) {
      var _this$props = _this.props,
          row = _this$props.row,
          value = _this$props.value,
          onChange = _this$props.onChange;

      var answerObj = _extends({}, value, _defineProperty({}, questionId, { value: questionValue }));
      onChange(row.id, answerObj);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MatrixRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          row = _props.row,
          questions = _props.questions,
          answer = _props.answer;

      return _react2.default.createElement(
        'div',
        { role: 'group', 'aria-labelledby': 'row_head', className: 'MatrixRow' },
        _react2.default.createElement(
          'div',
          { id: 'row_head', className: 'MatrixRow-legend' },
          row.text
        ),
        questions.map(function (question) {
          return _react2.default.createElement(_QuestionHolder2.default, _extends({
            answer: answer[question.id] && answer[question.id]['value'],
            key: question.id
          }, question, {
            displayType: question.display_type,
            onChange: _this2.handleChange
          }));
        })
      );
    }
  }]);

  return MatrixRow;
}(_react.Component);

MatrixRow.propTypes = {
  row: _propTypes2.default.any.isRequired,
  questions: _propTypes2.default.any.isRequired,
  value: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired
};

MatrixRow.defaultProps = {
  answer: {}
};

exports.default = MatrixRow;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Survey/MatrixRow.js
// module id = 455
// module chunks = 0